import { useOutletContext } from "react-router-dom";
import { hasActiveAccess } from "../../../utils/subscription";

export default function useMarketDataSubscription() {
  const { user: contextUser } = useOutletContext() || {};
  let user = contextUser;
  if (!user) {
    try {
      user = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      user = null;
    }
  }
  return hasActiveAccess(user);
}
